// extracted by mini-css-extract-plugin
module.exports = {"root":"Spinner_root__32SLa"};